import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { mobileWarningModalShownSelector } from 'Containers/Dashboard/selector';

import { setMobileWarningModalShown } from 'Containers/Dashboard/actions';

import { areEqual } from 'Utils/equalityChecks';
import { MobileWarningModal } from 'Components/MobileWarningModal';

const MobileWarningModalContainer = () => {
  const dispatch = useDispatch();

  // display mobile warning modal only on iOS devices, since the modal promotes the iOS App Store link
  const [isMobile] = useState(/iPhone|iPad|iPod/i.test(navigator.userAgent));

  const mobileWarningModalShown = useSelector(mobileWarningModalShownSelector, areEqual);

  // Modal should show only once. Closing the modal or using the continue anyways link will count as shown.
  const modalCloseClick = useCallback(() => {
    dispatch(setMobileWarningModalShown(true));
  }, []);

  return <MobileWarningModal isOpen={isMobile && !mobileWarningModalShown} modalCloseClick={modalCloseClick} />;
};

const MobileWarningModalContainerMemo = memo(MobileWarningModalContainer, areEqual);

export { MobileWarningModalContainerMemo as MobileWarningModalContainer };
